import React from "react";

export const EntityDetailContext = React.createContext(null);

export const useEntityDetailContext = () => {
  const context = React.useContext(EntityDetailContext);

  if (!context) throw new Error("Entity Detail Context not provided!");

  return context;
};
